/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandOrder } from '@alfa-client/command-shared';
import { HISTORIE_ITEM_RENDERERS } from '@alfa-client/historie-shared';
import { Provider } from '@angular/core';
import { HistorieItemAktenzeichenComponent } from './historie-item-aktenzeichen/historie-item-aktenzeichen.component';
import { HistorieItemVorgangStatusComponent } from './historie-item-vorgang-status/historie-item-vorgang-status.component';

const vorgangStatusOrders: CommandOrder[] = [
  CommandOrder.VORGANG_ANNEHMEN,
  CommandOrder.VORGANG_VERWERFEN,
  CommandOrder.VORGANG_ZURUECKHOLEN,
  CommandOrder.VORGANG_BEARBEITEN,
  CommandOrder.VORGANG_BESCHEIDEN,
  CommandOrder.VORGANG_ZURUECKSTELLEN,
  CommandOrder.VORGANG_ABSCHLIESSEN,
  CommandOrder.VORGANG_WIEDEREROEFFNEN,
];

export const vorgangHistorieProviders: Provider[] = [
  ...vorgangStatusOrders.map((commandOrder) => ({
    provide: HISTORIE_ITEM_RENDERERS,
    useValue: { commandOrder, component: HistorieItemVorgangStatusComponent },
    multi: true,
  })),
  {
    provide: HISTORIE_ITEM_RENDERERS,
    useValue: { commandOrder: CommandOrder.SET_AKTENZEICHEN, component: HistorieItemAktenzeichenComponent },
    multi: true,
  },
];
